import gql from 'graphql-tag';

export const SetPaymentStatusMutation = gql`
  mutation SetPaymentStatus($paymentId: ID!, $status: String!) {
    setPaymentStatus(data: {
      paymentId: $paymentId,
      status: $status,
    }) {
      id
      status
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/Query/Payment/SetPaymentStatus.tsx